import { AnimatePresence, motion } from "framer-motion";
import Button from "./button";
import { cn } from "../../lib/utils";

interface ErrorMessageProps {
    error: string;
    close: () => void;
    className?: string;
}

export default function ErrorMessage({ error, close, className }: ErrorMessageProps) {
    return (
        <AnimatePresence>
            {error && (
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }} className={cn("flex items-center gap-2 rounded-md bg-red-200 px-4 py-2 dark:bg-red-500", className)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-4 w-4 text-red-600 dark:text-red-900">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                    </svg>

                    <div className="flex-grow">{error}</div>
                    <Button type="button" variant={"ghost"} size={"ghost"} onClick={() => close()}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={4} stroke="currentColor" className="h-4 w-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </Button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
